








































































import Vue from 'vue';
import NavbarMenu from './Navbar/NavbarMenu.vue';
import { HubIcon } from './HubComponents';

export default Vue.extend({
  name: 'AppNavbar',

  components: {
    NavbarMenu,
    HubIcon,
  },

  data() {
    return {
      mini: false,
    };
  },

  methods: {
    toggleMini() {
      this.mini = !this.mini;
    },
  },
});
